import Reveal from "./Reveal";
import { IMAGES, whatsappLink } from "@/constants/site";

export default function NatureStory() {
  const waLink = whatsappLink(
    "Merhaba Düzbağ Life, rezervasyon talebi oluşturmak istiyorum."
  );

  return (
    <section className="relative w-full h-[70vh] min-h-[520px] overflow-hidden">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        poster={IMAGES.aerialRiver}
        aria-label="Düzbağ Life doğa ve bungalov tanıtım videosu"
      >
        <source src={IMAGES.video} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-foreground-950/80" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-8">
        <Reveal>
          <h2 className="font-heading text-background-50 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium leading-[1.15] tracking-wide">
            SUYUN SESİ.
            <br />
            DAĞLARIN SESSİZLİĞİ.
            <br />
            DÜZBAĞ LIFE.
          </h2>
          <p className="mt-6 text-background-200 text-sm md:text-base max-w-xl mx-auto">
            Doğanın ritmine birkaç günlüğüne de olsa geri dönün.
          </p>
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-9 inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold px-8 py-4 rounded-md whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg" />
            Rezervasyon Talebi Oluştur
          </a>
        </Reveal>
      </div>
    </section>
  );
}